import { render } from "./ProductClassIconList.vue?vue&type=template&id=b88c5490&scoped=true&ts=true"
import script from "./ProductClassIconList.vue?vue&type=script&lang=ts"
export * from "./ProductClassIconList.vue?vue&type=script&lang=ts"

import "./ProductClassIconList.vue?vue&type=style&index=0&id=b88c5490&lang=scss&scoped=true"
import "./ProductClassIconList.vue?vue&type=style&index=1&id=b88c5490&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88c5490"]])

export default __exports__